module.exports = __webpack_public_path__ + "img/10.b79d4227.jpg";